import $ from "jquery";
import { NOTICE_TYPES, showToast } from "./toast";

$(function () {
    if ($(".woocommerce .product-image-slider").length) {
        const galleryThumbs = new window.Swiper(".woocommerce .product-thumbnail-slider", {
            slidesPerView: 3,
            spaceBetween: "16",
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            scrollbar: {
                el: ".swiper-scrollbar",
                hide: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 3,
                },
                1024: {
                    slidesPerView: 5,
                },
                1280: {
                    slidesPerView: 6,
                },
            },
        });

        if ($(".woocommerce .product-thumbnail-slider").length) {
            const galleryTop = new window.Swiper(".woocommerce .product-image-slider", {
                loop: true,
                slidesPerView: 1,
                autoHeight: true,
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                },
                thumbs: {
                    swiper: galleryThumbs,
                },
            });
        }
    }
});

$(document).on("change input", ".woocommerce-cart-form .cart_item :input", function (e) {
    $('.woocommerce-cart-form :input[name="update_cart"]').prop("disabled", false);
});

$(document).on("click", ".plus", function (e) {
    const $input = $(this).siblings("input.qty");
    console.log($input);
    const $inputName = $input.attr("name");
    const $inputID = $input.attr("id");
    // Search for second input with the same name to work around correctly updating the cart.
    const $secondInput = $(`.woocommerce-cart input[name='${$inputName}']:not([id='${$inputID}'])`);
    const max = parseInt($input.attr("max"));
    const val = parseInt($input.val());
    let step = $input.attr("step");
    step = "undefined" !== typeof step ? parseInt(step) : 1;
    if (isNaN(max) || val < max) {
        $input.val(val + step).change();
        if ($secondInput.length !== 0) {
            $secondInput.val(val + step).change();
        }
    }
});
$(document).on("click", ".minus", function (e) {
    const $input = $(this).siblings("input.qty");
    const $inputName = $input.attr("name");
    const $inputID = $input.attr("id");
    // Search for second input with the same name to work around correctly updating the cart.
    const $secondInput = $(`.woocommerce-cart input[name='${$inputName}']:not([id='${$inputID}'])`);
    const val = parseInt($input.val());
    let step = $input.attr("step");
    step = "undefined" !== typeof step ? parseInt(step) : 1;
    if (val > 0) {
        $input.val(val - step).change();
        if ($secondInput.length !== 0) {
            $secondInput.val(val - step).change();
        }
    }
});

if (typeof frameworkData !== "undefined") {
    const ToastifyNotices = {
        init() {
            const enabled = (frameworkData.show_in_toast ?? []).filter((type) => type in NOTICE_TYPES);

            if (!enabled.length) {
                return;
            }

            // Notices already in the page at load.
            enabled.forEach((type) => {
                document.querySelectorAll(ToastifyNotices.selectorFor(type)).forEach((el) => {
                    ToastifyNotices.show(el, type);
                });
            });

            ToastifyNotices.observe(enabled);
        },

        /** The full selector for a notice type, child selector included when it has one. */
        selectorFor(type) {
            const { selector, childSelector } = NOTICE_TYPES[type];

            return childSelector ? `${selector} ${childSelector}` : selector;
        },

        show(element, type) {
            showToast(element.innerHTML.trim(), type, { close: true });
        },

        /**
         * One observer for every enabled type: three observers over the same
         * mutations would do one job three times.
         */
        observe(enabled) {
            const Observer = window.MutationObserver || window.WebKitMutationObserver;

            if (!Observer) {
                return;
            }

            const observer = new Observer((mutations) => {
                mutations.forEach(({ addedNodes }) => {
                    addedNodes.forEach((node) => {
                        // addedNodes carries text and comment nodes too, and
                        // matches()/querySelectorAll() exist only on elements.
                        if (node.nodeType !== Node.ELEMENT_NODE) {
                            return;
                        }

                        enabled.forEach((type) => {
                            const { selector, childSelector } = NOTICE_TYPES[type];
                            const full = ToastifyNotices.selectorFor(type);

                            // The node itself first, then anything matching inside it.
                            let found = node.matches(selector)
                                ? childSelector
                                    ? [...node.querySelectorAll(childSelector)]
                                    : [node]
                                : [];

                            if (!found.length) {
                                found = [...node.querySelectorAll(full)];
                            }

                            found.forEach((el) => ToastifyNotices.show(el, type));
                        });
                    });
                });
            });

            observer.observe(document.body, { childList: true, subtree: true });
        },
    };

    ToastifyNotices.init();
}
